export enum PendenciaRota {
    AGUARDANDO_CARREGAMENTO,
    AGUARDANDO_CONFIRMACAO,
    PROCESSANDO_LIBERACAO,
    SEM_PENDENCIA
}
